import { defaultShippingMetadata, mapShippingMethod, DEFAULT_COUNTRY_CODE, } from '@/modules/checkout/core/ShippingOptions';
import { $httpChangiRecommends, $httpPhoenix } from '@/core/api';
import { checkoutStepsSubmitStatus, } from '@/modules/checkout/core/CheckoutSteps';
import { mapShippingFormToDto, mapUserAddressToCheckoutAddress, } from '@/modules/checkout/models/ShippingAddressDto';
import { ChangiRecommends_SALES_CODE } from '@/core/contants';
import { defaultCustomerData, } from '@/modules/checkout/forms/ShippingDetailsForm';
import { getCountries } from '@/core/accountDetails';
import { ENV } from '@/env';
const state = {
    // Overall
    loading: false,
    loaded: false,
    activeStep: 'CUSTOMER_DETAILS',
    stepsStatus: {
        ...checkoutStepsSubmitStatus,
    },
    // Promo codes
    appliedPromoCode: null,
    discountAmount: null,
    discountState: 'NOT_APPLIED',
    discountErrorMsg: '',
    appliedOrderPromoCode: '',
    orderDiscountAmount: 0,
    totalOrderDiscountAmount: 0,
    applyPromoCodeErrorMsg: '',
    isApplyPromoCodeLoading: false,
    promoCodes: [],
    //Rewards Points
    discountRewardPoints: null,
    discountRewardPointsDivisor: null,
    // Addresses
    selectedShipping: null,
    selectedBilling: null,
    billingSameAsShipping: true,
    customerData: null,
    additionalData: null,
    detailsFilled: false,
    countries: [],
    // Shipping section
    selectedShippingMethod: null,
    shippingMethods: [],
    freeShippingScale: 0,
    shippingMetadata: defaultShippingMetadata,
    deliveryFilled: false,
    // Payment section
    availablePaymentMethods: [],
    selectedPaymentMethod: null,
    paymentToken: null,
    paymentSubmitted: false,
    paymentFilled: false,
    // Marketing integrations
    isCustomerSubscribed: null,
    signInToNewsletter: false,
    subscriptionAmount: 0,
    // Order settling
    settledOrder: null,
};
export function mapUserDataToCustomerDetails(userData) {
    return {
        name: userData?.name ?? userData?.data?.name ?? '',
        email: userData?.email ?? userData?.data?.email ?? '',
        phone: userData?.phone ?? userData?.data?.phone ?? '',
        phoneCountryUuid: userData?.phoneCountryUuid ?? userData?.data?.phoneCountryUuid ?? '',
        emailConfirmed: false,
    };
}
const actions = {
    // Analytics
    pushAnalyticsDataAboutOrder({}, order) {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
            ecommerce: {
                purchase: {
                    actionField: {
                        id: order.orderCode,
                        affiliation: 'ChangiRecommends by ChangiRecommends',
                        revenue: order.orderDetails?.summary?.amount / 100,
                        tax: order.orderDetails?.summary?.products?.taxAmount / 100,
                        shipping: order.orderDetails?.summary?.shipping?.total / 100,
                        coupon: order.orderDetails?.summary?.discount?.promoCode ?? null,
                    },
                    products: [
                        order.orderDetails?.products?.map((product) => {
                            return {
                                id: product.unitUuid,
                                name: product.productName,
                                price: product.amount.amount / 100,
                                brand: product.productBrand ? product.productBrand.name : null,
                                variant: product.variantName ?? null,
                                quantity: product.quantity,
                            };
                        }),
                    ],
                },
            },
        });
    },
    // Shipping
    fetchShippingMethods({ state, commit, }) {
        $httpPhoenix.api.getShippingMethods(ChangiRecommends_SALES_CODE).then((resp) => {
            const data = resp.data.data?.data ?? [];
            if (!data)
                throw new Error('No Shipping methods');
            const sortByOrder = (a, b) => (a.order ?? 0) - (b.order ?? 0);
            const shippingMethods = data.map(mapShippingMethod).sort(sortByOrder);
            commit('setShippingMethods', shippingMethods);
        });
    },
    // Promo codes
    async applyPromoCode({ state, commit, getters }, promoCode) {
        if (promoCode == '') {
            commit('setDiscountAmount', null);
            commit('setAppliedPromoCode', null);
            return;
        }
        return $httpPhoenix.api
            .orderDiscountPreview({
            products: getters.getCartProductsForCheckout,
            promoCode: promoCode,
            salesChannelCode: ChangiRecommends_SALES_CODE,
            currencyCode: 'SGD',
            referenceOrderCode: '',
        })
            .then((resp) => {
            if (resp.data.discounted) {
                commit('setAppliedPromoCode', resp.data.promoCode);
                commit('setDiscountAmount', resp.data.discountAmount);
                commit('setDiscountState', 'APPLIED');
            }
            else {
                commit('setAppliedPromoCode', null);
                commit('setDiscountAmount', null);
                commit('setDiscountState', 'INVALID');
                commit('setDiscountErrorMsg', 'Promo code is not valid.');
                throw new Error('Promo code not applicable');
            }
        })
            .catch((err) => {
            if (err.response.data.exceptionMsg) {
                commit('setDiscountErrorMsg', err.response.data.exceptionMsg);
            }
            else {
                commit('setDiscountErrorMsg', 'Promo code is not valid.');
            }
            commit('setAppliedPromoCode', null);
            commit('setDiscountState', 'INVALID');
        });
    },
    //Rewards Points
    applayedRewardPoints({ commit }, value) {
        commit('setDiscountRewardPoints', value.customerRewardPoints);
        commit('setDiscountRewardPointsDivisor', value.pointsDivisor);
    },
    // Address
    loadCountries({ state, commit, }) {
        if (state.countries.length === 0) {
            $httpPhoenix.api
                .countries()
                .then((resp) => {
                commit('setCountries', resp.data);
            })
                .catch((err) => console.error(err));
        }
    },
    // Shipping
    loadFreeShipping({ commit }) {
        $httpChangiRecommends.api.ChangiRecommendsFreeShippingOrderAmount().then((resp) => {
            commit('setFreeShippingScale', resp.data.result);
        });
    },
    // Payment
    loadPaymentMethods({ commit }) {
        $httpPhoenix.api.getPaymentMethodsList(ChangiRecommends_SALES_CODE).then((resp) => {
            commit('setAvailablePaymentMethods', resp.data.data.data ?? []);
        });
    },
    // Marketing
    checkIfIsSubscribed({ commit, state }, force = false) {
        $httpChangiRecommends.api
            .ChangiRecommendsNewsletterIsSubscribed({
            email: state.customerData?.email,
            subscribe: force,
        })
            .then((resp) => {
            commit('setSubscriptionStatus', resp.data.subscribed);
            commit('setSubscriptionAmount', resp.data.amount);
        })
            .catch((err) => {
            console.error(err);
        });
    },
    // @todo check how it works
    async initAsyncState({ commit, state, }) {
        try {
            const resp = await $httpChangiRecommends.api.getUserData();
            const user = resp.data;
            if (user.phoneCountryUuid === null) {
                await getCountries().then((resp) => {
                    let defaultCountry = resp.find((country) => country.code === DEFAULT_COUNTRY_CODE);
                    user.phoneCountryUuid = defaultCountry.uuid;
                    user.phoneCountry = defaultCountry.name;
                });
            }
            commit('userModule/setUser', user || null, { root: true });
            const address = user?.addresses?.find((a) => a.isDefault) ?? null;
            if (address) {
                // @todo unify user and checkout form model
                const checkoutAddress = mapUserAddressToCheckoutAddress(address);
                commit('setCustomerData', mapUserDataToCustomerDetails(user));
                commit('userModule/setDefaultAddress', checkoutAddress, { root: true });
                commit('setSelectedShipping', checkoutAddress);
                commit('setSelectedBilling', checkoutAddress);
                // commit('setStepsStatus', { step: state.activeStep });
                // commit('setActiveStep', nextStep(state.activeStep));
            }
        }
        catch (err) {
            commit('userModule/setUser', null, { root: true });
            return err;
        }
    },
    clearCheckoutForm({ commit, dispatch, }) {
        commit('clearCheckoutSelections');
        dispatch('cartModule/clearCart', null, { root: true });
    },
    clearCheckoutData({ commit, dispatch, }) {
        commit('clearCheckoutSelections');
        dispatch('cartModule/clearCart', null, { root: true });
    },
    // Order settling
    async createOrder({ state, commit, getters, dispatch, }) {
        let priceGroup = '';
        const cartItems = getters.getCartProductsForCheckout;
        for (const item of cartItems) {
            if (item.priceGroup) {
                priceGroup = item.priceGroup;
                break;
            }
        }
        const changiAccountUid = await getters.getChangiAccountUid;
        return await $httpChangiRecommends.api
            .createChangiRecommendsOrder({
            shippingAddress: state.selectedShipping
                ? mapShippingFormToDto(state.selectedShipping)
                : undefined,
            billingAddress: state.selectedBilling
                ? mapShippingFormToDto(state.selectedBilling)
                : undefined,
            products: getters.getCartProductsForCheckout,
            paymentMethodUuid: state.selectedPaymentMethod
                ? state.selectedPaymentMethod.uuid
                : '',
            shippingMethodUuid: state.selectedShippingMethod
                ? state.selectedShippingMethod.uuid
                : null,
            shippingMethodMetaData: state.shippingMetadata,
            paymentToken: state.paymentToken ? state.paymentToken.id : null,
            billingAddressSameAsCustomerDeliveryAddress: state.billingSameAsShipping,
            useCustomerDeliveryAddress: false,
            customerAddress: state.selectedBilling
                ? mapShippingFormToDto(state.selectedBilling)
                : undefined,
            customer: state.customerData,
            additionalData: state.additionalData,
            //promoCode: state.appliedPromoCode ? state.appliedPromoCode.code : null,
            promoCode: state.appliedOrderPromoCode ? state.appliedOrderPromoCode : null,
            customerRewardPoints: state.discountRewardPoints,
            signInToNewsletter: state.signInToNewsletter,
            successUrl: window.location.origin + '/checkout-confirmation',
            cancelUrl: window.location.origin + '/payment-failure',
            priceGroup: priceGroup,
            changiAccountUid: changiAccountUid,
        })
            .then((resp) => {
            commit('setDiscountRewardPoints', 0);
            commit('setDiscountRewardPointsDivisor', 0);
            commit('setSettledOrder', resp.data.Order);
            if (window.dataLayer) {
                dispatch('pushAnalyticsDataAboutOrder', resp.data.Order);
            }
            return resp.data.Order;
        })
            .catch((err) => {
            throw new Error(err.data?.message);
        });
    },
    async getAvailablePromoCodes({ commit, getters, dispatch, }) {
        //commit('setApplyPromoCodeLoading', true);
        const xProduct = (window.location.hostname.split('.')[0] || 'changirecommends').replace('pre-prod-', '');
        const cartProducts = getters.getCartProductsForCheckout;
        ;
        const changiAccountUid = await getters.getChangiAccountUid;
        //const changiAccountUid =  "0fffb0f46bbd4bee8a56f4801b0f1fa8"; 
        const url = `${ENV.API_BASE_URL}/shop/available-promo-codes`;
        try {
            const res = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'X-Product': xProduct,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    changiAccountUid,
                    products: cartProducts
                })
            });
            if (res.ok) {
                const data = await res.json();
                if (data?.data?.result?.data) {
                    const codes = Array.isArray(data.data.result.data) ? data.data.result.data : [];
                    commit('setPromoCodes', codes);
                }
                else {
                    commit('setPromoCodes', []);
                }
            }
            else {
                console.error('getAvailablePromoCodes error:', res);
                commit('setPromoCodes', []);
            }
        }
        catch (error) {
            console.error('fetch available promoCodes failed:', error);
            commit('setPromoCodes', []);
        }
        finally {
            await dispatch('checkoutModule/checkAppliedPromoCode', null, { root: true });
            //commit('setApplyPromoCodeLoading', false);
        }
    },
    async checkAppliedPromoCode({ commit, rootState, state, }) {
        const validOrderCodes = new Set(state.promoCodes
            .filter(p => p.is_order_level === true)
            .map(p => p.code));
        if (!validOrderCodes.has(state.appliedOrderPromoCode)) {
            commit('setAppliedOrderPromoCode', null);
        }
        const validProductCodes = new Set(state.promoCodes
            .filter(p => p.is_order_level === false)
            .map(p => p.code));
        const validProductPromos = rootState.cartModule.productPromoCodes.filter(item => validProductCodes.has(item.promoCode));
        commit('cartModule/setProductPromoCodes', validProductPromos, { root: true });
    },
    async callApplyOrderPromoCode({ commit, state, rootState, getters, dispatch, }, payload = null) {
        let code = payload;
        let showLoading = true;
        if (payload &&
            typeof payload === 'object' &&
            !Array.isArray(payload)) {
            code = payload.code !== undefined ? payload.code : null;
            showLoading =
                payload.showLoading !== undefined ? payload.showLoading : true;
        }
        const orderPromoCode = code !== null ? code : state.appliedOrderPromoCode;
        if (showLoading) {
            commit('setApplyPromoCodeLoading', true);
        }
        commit('setApplyPromoCodeErrorMsg', null);
        const xProduct = (window.location.hostname.split('.')[0] || 'changirecommends').replace('pre-prod-', '');
        const url = `${ENV.API_BASE_URL}/shop/apply-promo-code`;
        //console.log(cartProducts);
        // const cartItems = getters.getCartProductsForCheckout; 
        const productPromoCodes = rootState.cartModule.productPromoCodes;
        const changiAccountUid = await getters.getChangiAccountUid;
        //const changiAccountUid =  "0fffb0f46bbd4bee8a56f4801b0f1fa8"; 
        const cartProducts = getters.getCartProductsForCheckout;
        console.log('cart length: ' + cartProducts.length);
        if (cartProducts.length <= 0) {
            commit('setAppliedOrderPromoCode', null);
            commit('setOrderDiscountAmount', 0);
            commit('setTotalOrderDiscountAmount', 0);
            commit('setApplyPromoCodeLoading', false);
        }
        else {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'X-Product': xProduct,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        changiAccountUid: changiAccountUid,
                        promoCode: orderPromoCode,
                        products: cartProducts,
                    }),
                });
                if (res.ok) {
                    const data = await res.json();
                    if (data?.data?.result) {
                        let totalOrderDiscountAmount = 0;
                        if (data.data.result.orderDiscount) {
                            commit('setAppliedOrderPromoCode', orderPromoCode);
                            commit('setOrderDiscountAmount', data.data.result.orderDiscount.discountAmountDecimal);
                            totalOrderDiscountAmount += data.data.result.orderDiscount.discountAmountCents / 100;
                        }
                        else {
                            commit('setAppliedOrderPromoCode', null);
                            commit('setOrderDiscountAmount', 0);
                        }
                        if (data.data.result.productDiscount) {
                            for (const product of data.data.result.productDiscount) {
                                //const targetCode = productPromoCodes.find(p => p.productUnitUuid === product.productUnitUuid);
                                //if (targetCode) {
                                const newDiscount = product.discount ? product.discount.discountAmountCents / 100 : 0;
                                commit('cartModule/updatePromoCodeDiscount', {
                                    productUnitUuid: product.productUnitUuid,
                                    discountAmount: newDiscount
                                }, { root: true });
                                commit('cartModule/addOrUpdateProductPromoCodes', {
                                    productUnitUuid: product.productUnitUuid,
                                    promoCode: product.promoCode,
                                    discountAmount: newDiscount
                                }, { root: true });
                                totalOrderDiscountAmount += newDiscount;
                                //}
                            }
                        }
                        commit('setTotalOrderDiscountAmount', totalOrderDiscountAmount);
                    }
                    else {
                        commit('setApplyPromoCodeErrorMsg', 'This voucher is currently not available.');
                        // await dispatch('checkoutModule/removeOrderPromoCode', null, { root: true });
                    }
                }
                else {
                    //await dispatch('checkoutModule/removeOrderPromoCode', null, { root: true });
                    commit('setApplyPromoCodeErrorMsg', 'This voucher is currently not available.');
                    console.error(res);
                }
            }
            catch (error) {
                commit('setApplyPromoCodeErrorMsg', 'This voucher is currently not available.');
                console.error('Apply promo code error:', error);
                // await dispatch('checkoutModule/removeOrderPromoCode', null, { root: true });
            }
            finally {
                commit('setApplyPromoCodeLoading', false);
            }
        }
    },
    async removeOrderPromoCode({ commit }) {
        commit('setAppliedOrderPromoCode', null);
        commit('setOrderDiscountAmount', 0);
        commit('setTotalOrderDiscountAmount', 0);
    },
};
const mutations = {
    // Overall
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoaded(state, loaded) {
        state.loaded = loaded;
    },
    setStepsStatus(state, { step, status = true }) {
        const stepsStatus = { ...state.stepsStatus };
        stepsStatus[step] = status;
        state.stepsStatus = { ...stepsStatus };
    },
    setActiveStep(state, step) {
        state.activeStep = step;
    },
    // Promo codes
    setAppliedPromoCode(state, payload) {
        state.appliedPromoCode = payload;
    },
    setDiscountAmount(state, payload) {
        state.discountAmount = payload;
    },
    setDiscountState(state, payload) {
        state.discountState = payload;
    },
    setDiscountErrorMsg(state, payload) {
        state.discountErrorMsg = payload;
    },
    setAppliedOrderPromoCode(state, payload) {
        state.appliedOrderPromoCode = payload;
    },
    setOrderDiscountAmount(state, payload) {
        state.orderDiscountAmount = payload;
    },
    setTotalOrderDiscountAmount(state, payload) {
        state.totalOrderDiscountAmount = payload;
    },
    setApplyPromoCodeErrorMsg(state, payload) {
        state.applyPromoCodeErrorMsg = payload;
    },
    setApplyPromoCodeLoading(state, loading) { state.isApplyPromoCodeLoading = loading; },
    setPromoCodes(state, codes) {
        state.promoCodes = codes;
    },
    //Reward Points
    setDiscountRewardPoints(state, payload) {
        state.discountRewardPoints = payload;
    },
    setDiscountRewardPointsDivisor(state, payload) {
        state.discountRewardPointsDivisor = payload;
    },
    // Address
    setCountries(state, payload) {
        state.countries = payload;
    },
    setSelectedShipping(state, addressView) {
        state.selectedShipping = addressView ? { ...addressView } : null;
    },
    setSelectedBilling(state, addressView) {
        state.selectedBilling = addressView ? { ...addressView } : null;
    },
    setCustomerData(state, payload) {
        state.customerData = payload;
    },
    setCustomerDataField(state, { field, value }) {
        if (!state.customerData) {
            state.customerData = { ...defaultCustomerData };
        }
        state.customerData = {
            ...state.customerData,
            [field]: value,
        };
    },
    setAdditionalData(state, payload) {
        state.additionalData = payload;
    },
    setBillingSameAsDelivery(state, payload) {
        state.billingSameAsShipping = payload;
    },
    setDetailsFilled(state, value) {
        state.detailsFilled = value;
    },
    // Shipping
    setFreeShippingScale(state, amount) {
        state.freeShippingScale = amount;
    },
    setShippingMethods(state, shippingMethods) {
        state.shippingMethods = [...shippingMethods];
    },
    selectShippingMethod(state, shippingMethod) {
        state.selectedShippingMethod = { ...shippingMethod };
    },
    setShippingMetadata(state, payload) {
        state.shippingMetadata = payload;
    },
    setDeliveryFilled(state, value) {
        state.deliveryFilled = value;
    },
    // Payment
    setAvailablePaymentMethods(state, methods) {
        state.availablePaymentMethods = methods;
    },
    setSelectedPaymentMethod(state, method) {
        state.selectedPaymentMethod = method;
    },
    setPaymentToken(state, paymentToken) {
        state.paymentToken = paymentToken;
    },
    setPaymentSubmitted(state, newValue) {
        state.paymentSubmitted = newValue;
    },
    setPaymentFilled(state, value) {
        state.paymentFilled = value;
    },
    // Marketing
    setSubscriptionStatus(state, value) {
        state.isCustomerSubscribed = value;
    },
    setSignInToNewsletter(state, value) {
        state.signInToNewsletter = value;
    },
    setSubscriptionAmount(state, value) {
        state.subscriptionAmount = value;
    },
    // After order
    setSettledOrder(state, payload) {
        state.settledOrder = payload;
    },
    clearCheckoutSelections(state) {
        state.selectedShipping = null;
        state.selectedBilling = null;
        state.billingSameAsShipping = true;
        state.appliedPromoCode = null;
        state.appliedOrderPromoCode = null;
        state.orderDiscountAmount = 0;
        state.totalOrderDiscountAmount = 0;
        state.isApplyPromoCodeLoading = false;
        state.promoCodes = [];
        state.applyPromoCodeErrorMsg = null;
        state.selectedShippingMethod = null;
        state.shippingMetadata = defaultShippingMetadata;
        state.selectedPaymentMethod = null;
        state.paymentSubmitted = false;
        state.customerData = defaultCustomerData;
        state.activeStep = 'CUSTOMER_DETAILS';
        state.stepsStatus = checkoutStepsSubmitStatus;
    },
};
const getters = {
    orderTotal(state, getters, rootState, rootGetters) {
        let cartTotal = rootGetters['cartModule/cartItemsPrice'];
        if (cartTotal -
            getters['promoCodeDiscountAmount'] -
            getters['rewardPointsDiscountAmount'] <
            0) {
            cartTotal = 0;
        }
        else {
            cartTotal =
                cartTotal -
                    getters['promoCodeDiscountAmount'] -
                    getters['rewardPointsDiscountAmount'];
        }
        if (state.selectedShippingMethod &&
            state.selectedShippingMethod.amount !== 0 &&
            (!getters.isFreeShippingAmountReached ||
                !state.selectedShippingMethod.isFreeShippingApplicable)) {
            cartTotal = cartTotal + state.selectedShippingMethod.amount;
        }
        return parseFloat(cartTotal.toFixed(2));
    },
    promoCodeDiscountAmount(state) {
        if (state.appliedPromoCode && state.discountAmount) {
            return state.discountAmount / 100;
        }
        return 0;
    },
    promoCodeDiscountAmountPercentage(state, getters, rootState, rootGetters) {
        let cartTotal = rootGetters['cartModule/cartItemsPrice'];
        if (state.appliedPromoCode) {
            if (state.appliedPromoCode.batchSettings.pricePercentage &&
                state.appliedPromoCode.batchSettings.promoCodeType === 'Percentage') {
                return parseFloat((cartTotal *
                    (state.appliedPromoCode.batchSettings.pricePercentage / 100)).toFixed(2));
            }
        }
        return 0;
    },
    rewardPointsDiscountAmount: (state) => {
        if (state.discountRewardPoints && state.discountRewardPointsDivisor) {
            return state.discountRewardPoints / state.discountRewardPointsDivisor;
        }
        return 0;
    },
    isFreeShippingAmountReached(state, getters, rootState, rootGetters) {
        let cartTotal = rootGetters['cartModule/cartItemsPrice'];
        return (cartTotal - getters['promoCodeDiscountAmount'] >= state.freeShippingScale);
    },
    getCartProductsForCheckout(state, getters, rootState) {
        const activeProducts = rootState.cartModule.items.filter((item) => {
            return item.status == true;
        });
        const productPromoCodes = rootState.cartModule.productPromoCodes;
        return activeProducts.map((item) => {
            let priceGroup = null;
            let numberOfDays = null;
            if (item.crossSellUuid && item.crossSellOrder) {
                priceGroup = item.crossSellOrder.data.Order.policy.priceGroup.name;
                numberOfDays = item.crossSellOrder.data.Order.policy.totalTravellingDays;
            }
            let exists = productPromoCodes.find(p => p.productUnitUuid === item.selectedUnitUuid);
            return {
                productUnitUuid: item.selectedUnitUuid,
                quantity: item.quantity,
                selectedDate: item.selectedDate,
                selectedTime: item.selectedTime,
                type: item.product.product_type.system_key,
                metaData: [],
                priceGroup: priceGroup,
                numberOfDays: numberOfDays,
                isIntegratedCheckout: true,
                apiHubUuid: item.crossSellOrder ? item.crossSellOrder.data.Uuid : null,
                apiHubPlatform: item.crossSellOrder ? item.crossSellOrder.data.PlatformKey : null,
                apiHubBusinessUnit: item.crossSellOrder ? item.crossSellOrder.data.BusinessUnitKey : null,
                promoCode: exists ? exists.promoCode : null,
            };
        });
    },
    async getChangiAccountUid(state, getters, rootState) {
        let accountDetailsResp = await $httpChangiRecommends.api.getUserData().catch((err) => {
            return {
                data: {
                    data: null,
                },
            };
        });
        return accountDetailsResp.data?.data?.changiAccountUid ?? '';
    },
};
export const checkoutModule = {
    state,
    mutations,
    actions,
    namespaced: true,
    getters,
};
